import { memo } from 'react'
import { Fade, IconButton, styled } from '@mui/material'
import Badge, { BadgeProps } from '@mui/material/Badge'
import { scrollToMessageByIid, useOpenedRoomId } from '$logic/opened-room'
import { toLocale } from '$func/text'
import { AlternateEmailIcon } from '$common/icons'
import { useSubscription } from '$logic/subscription/react-hook'

const StyledIconButton = styled(IconButton)`
  width: 44px;
  height: 44px;
  padding: 10px;
  border-radius: 50%;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  &:hover {
    background-color: #f6f6f6;
  }
`

const StyledBadge = styled(Badge)<BadgeProps>(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: '50%',
    padding: '5px 8px',
    lineHeight: '8px',
    color: theme.palette.white,
    ...theme.typography.caption1,
  },
}))

export const ScrollToMention = memo(function ScrollToMentionComponent() {
  const roomId = useOpenedRoomId()
  const { entity: subscription, loading } = useSubscription(roomId)
  const mentionCount = subscription?.mentions?.length
  if (loading || !mentionCount) return null

  return (
    <Fade in>
      <div>
        <StyledBadge
          badgeContent={toLocale(mentionCount)}
          invisible={!mentionCount}
          color="secondary"
        >
          <StyledIconButton
            onClick={() => scrollToMessageByIid(subscription.mentions![0])}
          >
            <AlternateEmailIcon
              sx={{ width: '20px', height: '20px', color: 'gray' }}
            />
          </StyledIconButton>
        </StyledBadge>
      </div>
    </Fade>
  )
})
